import { render, staticRenderFns } from "./DetailNpwp.vue?vue&type=template&id=46a147b6"
import script from "./DetailNpwp.vue?vue&type=script&lang=js"
export * from "./DetailNpwp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports